import React from "react";
import { Avatar, SxProps } from "@mui/material";
import { Group as FamilyIcon } from "@mui/icons-material";
import { Family } from "../../interfaces/DTO/crm/family";
import { Contact } from "../../interfaces/DTO/crm/contact";
import { User } from "../../interfaces/DTO/user";
import { formatName } from "../../utils/namesFormater";

interface CustomAvatarProps {
  item: Contact | User | Family;
  isUser: boolean; // true עבור Contact ו-User, false עבור Family
  userColor: string;
  familyColor: string;
  sx?: SxProps;
  customTextColor?: string; // צבע מותאם אישית לאות
  customBorder?: string; // מסגרת מותאמת אישית
  onClick?: () => void;
}

const CustomAvatar: React.FC<CustomAvatarProps> = ({
  item,
  isUser,
  userColor,
  familyColor,
  sx,
  customTextColor,
  customBorder,
  onClick,
}) => {
  const isContact = "first_name" in item && "last_name" in item;
  const isRealUser = "username" in item;

  const displayChar = isRealUser
    ? formatName(item as User).charAt(0).toUpperCase()
    : isContact
    ? `${(item as Contact).first_name ?? ""}`.trim().charAt(0).toUpperCase()
    : "";

  return (
    <Avatar
      onClick={onClick}
      sx={{
        backgroundColor: isUser ? userColor : familyColor,
        color: customTextColor,
        border: customBorder,
        ...sx,
      }}
    >
      {isUser ? displayChar : <FamilyIcon />}
    </Avatar>
  );
};

export default CustomAvatar;
